interface SectionPlaceholderProps {
  sectionName: string;
}

export function SectionPlaceholder({ sectionName }: SectionPlaceholderProps) {
  return (
    <div className="flex items-center rounded-xl border border-border bg-card py-4 px-6">
      <span className="h-2 w-2 rounded-full bg-sand-300 shrink-0" />
      <span className="ml-3 text-sm text-subtle">{sectionName}</span>
      <span className="ml-auto text-sm text-sand-300">Waiting...</span>
    </div>
  );
}
